const Item = require('../common/ItemV2.jsx');
const LineItemCell = require('../common/LineItemCell.jsx');
const Name = require('../utility/Name.jsx');
const Token = require('../utility/Token.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region META

const TokensMeta = (data) => {
    // Discount
    const discountToken = Token.getCurrencyTokenConfig('Discount', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Discount, Token.firstLineCurrencyDifferentToggleOption);
    discountToken.options.splice(0, 0, { display: 'Display Text When Zero', name: 'displayZero' });
    const defaultValue = Utilities.Format.Percent.getDefaultFormatString()
    discountToken.options.push(
        { defaultValue, display: 'Percent Format', name: 'percentFormat', note: 'Keywords: [Value]', type: 'percentFormat' },
        { defaultValue, name: 'percentFormatFirst', toggle: { display: 'Format first line percentage differently?', label: 'First Line Percent Format', name: 'percentFormatFirst' }, type: 'percentFormat' }
    )

    // Price
    const priceToken = Token.getCurrencyTokenConfig('Retail Price', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Inventory.Price, Token.firstLineCurrencyDifferentToggleOption);
    priceToken.options.splice(0, 0, { defaultValue: 'true', label: 'Include if no discount?', name: 'noDiscount', type: 'toggle', value: 'true' });

    // Price (Display Currency)
    const priceDisplayCurrencyToken = Token.getWrappedTokenConfig('Retail Price (Display Currency)', Token.DisplayCurrency.Price);
    priceDisplayCurrencyToken.options.splice(0, 0, { defaultValue: 'true', label: 'Include if no discount?', name: 'noDiscount', type: 'toggle', value: 'true' });
    return [
        Token.getWrappedTokenConfig('Artist Name', Token.Artist.Name),
        Token.getWrappedTokenConfig('Title', Token.Inventory.Title),
        Token.getWrappedTokenConfig('Edition Info', Token.Inventory.Edition),
        Token.getWrappedTokenConfig('Created Date', Token.Date),
        Token.getWrappedTokenConfig('Medium', Token.Inventory.Medium),
        Token.getWrappedTokenConfig('Signature Placement', Token.Inventory.Signature),
        Token.getWrappedTokenConfig('Dimensions', Token.Inventory.Dimensions),
        Token.getWrappedTokenConfig('Alternate Dimensions', Token.Inventory.AlternateDimensions),
        Token.getWrappedTokenConfig('Inventory Number', Token.Inventory.Number),
        Token.getWrappedTokenConfig('SKU', Token.Inventory.SKU),
        discountToken,
        Token.getWrappedTokenConfig('Discount (Display Currency)', Token.DisplayCurrency.Discount),
        priceToken,
        priceDisplayCurrencyToken,
        Token.getCurrencyTokenConfig('Subtotal', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Total.Subtotal, Token.firstLineCurrencyDifferentToggleOption),
        Token.getWrappedTokenConfig('Subtotal (Display Currency)', Token.DisplayCurrency.Subtotal),
        Token.getWrappedTokenConfig('Quantity', Token.Inventory.Quantity)
    ]
}

// #endregion META

// #region CONTAINER

const TypeConfigLineItemContainer = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "columnCount": "6",
                            "collapseIfEmpty-col1": false,
                            "alignmentHeader-col1": "tl",
                            "alignment-col1": "tl",
                            "paddingRight-col1": {
                                "unit": "px",
                                "value": "10"
                            },
                            "paddingRightHeader-col1": {
                                "unit": "px",
                                "value": "10"
                            },
                            "width-col1": {
                                "unit": "px",
                                "value": "100"
                            },
                            "alignmentHeader-col2": "tl",
                            "alignment-col2": "tl",
                            "paddingRight-col2": {
                                "unit": "px",
                                "value": "10"
                            },
                            "paddingRightHeader-col2": {
                                "unit": "px",
                                "value": "10"
                            },
                            "width-col2": {
                                "unit": "%",
                                "value": ""
                            },
                            "alignmentHeader-col3": "tl",
                            "alignment-col3": "tl",
                            "paddingRight-col3": {
                                "unit": "px",
                                "value": "10"
                            },
                            "paddingRightHeader-col3": {
                                "unit": "px",
                                "value": "10"
                            },
                            "width-col3": {
                                "unit": "%",
                                "value": "10"
                            },
                            "alignmentHeader-col4": "tl",
                            "alignment-col4": "tl",
                            "collapseIfEmpty-col4": true,
                            "paddingRight-col4": {
                                "unit": "px",
                                "value": "10"
                            },
                            "paddingRightHeader-col4": {
                                "unit": "px",
                                "value": "10"
                            },
                            "width-col4": {
                                "unit": "%",
                                "value": "15"
                            },
                            "alignmentHeader-col5": "tl",
                            "alignment-col5": "tl",
                            "collapseIfEmpty-col5": true,
                            "paddingRight-col5": {
                                "unit": "px",
                                "value": "10"
                            },
                            "paddingRightHeader-col5": {
                                "unit": "px",
                                "value": "10"
                            },
                            "width-col5": {
                                "unit": "%",
                                "value": "15"
                            },
                            "alignmentHeader-col6": "tl",
                            "alignment-col6": "tl",
                            "width-col6": {
                                "unit": "%",
                                "value": "15"
                            },
                            "designHeader-col2": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:center;"`, text: 'Item', textExtras: `style="font-weight:bold;"` }),
                            "designHeader-col3": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:center;"`, text: 'Quantity', textExtras: `style="font-weight:bold;"` }),
                            "designHeader-col4": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: 'Price', textExtras: `style="font-weight:bold;"` }),
                            "designHeader-col5": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:center;"`, text: 'Discount', textExtras: `style="font-weight:bold;"` }),
                            "designHeader-col6": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: 'Subtotal', textExtras: `style="font-weight:bold;"` }),
                            "renderHeaderOnlyFirst": true,
                            "spacing": {
                                "unit": "px",
                                "value": "10"
                            }
                        },
                        "Style": {}
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                    "type": {
                        "value": "columns"
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "Block": {},
                                    "Style": {
                                        "textAlign": "center"
                                    }
                                },
                                "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Image
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": `${Utilities.wrapTextForEditor({ text: `{${Token.Artist.Name}("before":"","after":"")}`, token: Token.Artist.Name })}<p class="p">${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Inventory.Title, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.Edition, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Medium}("before":"","after":"")}`, token: Token.Inventory.Medium })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Dimensions}("before":"","after":"")}`, token: Token.Inventory.Dimensions })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.AlternateDimensions}("before":"","after":"")}`, token: Token.Inventory.AlternateDimensions })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.SKU}("before":"SKU: ","after":"")}`, token: Token.Inventory.SKU })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Number}("before":"Inventory #: ","after":"")}`, token: Token.Inventory.Number })}`
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-1-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:center;"`, text: `{${Token.Inventory.Quantity}("before":"","after":"")}`, token: Token.Inventory.Quantity })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-2-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Inventory.Price}("noDiscount":"true","format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}","formatFirst":"")}`, token: Token.Inventory.Price })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-3-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:center;"`, text: `{${Token.Discount}("displayZero":"0","format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}","formatFirst":"","percentFormat":"${Utilities.Format.Percent.getDefaultFormatString()}","percentFormatFirst":"")}`, token: Token.Discount })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-4-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:right;"`, text: `{${Token.Total.Subtotal}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}","formatFirst":"")}`, token: Token.Total.Subtotal })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-5-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ]
                    ]
                }
            ]
        },
        "Type": Name.Content.InvoiceLineItem
    })
}

// #endregion CONTAINER

module.exports = {
    Container: {
        ...LineItemCell.Container,
        TypeConfig: TypeConfigLineItemContainer
    },
    Image: Item.Image,
    Meta: {
        ...Item.Meta,
        Tokens: TokensMeta
    }
}